import { FC } from 'react';
import styled from 'styled-components';

type Props = {
  color: string;
  bgColor: string;
};
/* eslint-disable @typescript-eslint/no-unused-vars */
const ChipComponent: FC<Props> = ({ color, bgColor, ...props }) => {
  return <div {...props}></div>;
};
const Chip = styled(ChipComponent)`
  color: ${({ color }) => color};
  background-color: ${({ bgColor }) => bgColor};
  font-size: 0.9rem;
  border-radius: 50rem;
  padding: 0.15rem 0.5rem;
  text-align: center;
  width: fit-content !important;
  font-weight: 500;
  display: block;
  height: fit-content;
`;

export default Chip;
